import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { AnalyticsId, IconSize } from "../../constants.js";
import { palette } from "../../theme/palette.js";
import { I as Icon } from "../../Icon.js";
import { L as LazyIcon } from "../../LazyIcon.js";
import styles from "./styles.module.scss";
var TagSize = /* @__PURE__ */ ((TagSize2) => {
  TagSize2["medium"] = "medium";
  TagSize2["large"] = "large";
  return TagSize2;
})(TagSize || {});
var TagVariant = /* @__PURE__ */ ((TagVariant2) => {
  TagVariant2["normal"] = "normal";
  TagVariant2["oncolor"] = "oncolor";
  TagVariant2["emphasised"] = "emphasised";
  return TagVariant2;
})(TagVariant || {});
const Tag = (props) => {
  const { children, size = "medium", color = "blueberry", svgIcon, variant = "normal", testId } = props;
  const tagClasses = classNames(styles.tag, styles[`tag--${size}`], styles[`tag--${color}`], {
    [styles["tag--has-icon"]]: svgIcon,
    [styles["tag--emphasised"]]: variant == "emphasised"
    /* emphasised */
  });
  return /* @__PURE__ */ jsxs("span", { className: tagClasses, "data-testid": testId, "data-analyticsid": AnalyticsId.Tag, children: [
    svgIcon && (typeof svgIcon === "string" ? /* @__PURE__ */ jsx(LazyIcon, { iconName: svgIcon, size: IconSize.XXSmall, color: palette[`${color}800`], className: styles.tag__icon }) : /* @__PURE__ */ jsx(Icon, { svgIcon, size: IconSize.XXSmall, color: palette[`${color}800`], className: styles.tag__icon })),
    children
  ] });
};
export {
  TagSize,
  TagVariant,
  Tag as default
};
//# sourceMappingURL=index.js.map
